module.exports = __webpack_public_path__ + "static/media/a4.bf7d7901.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/ArcadeRoyale/a4.jpg
// module id = 164
// module chunks = 0